import { useApplicationStore } from '@/stores/application'

/**
 * Global middleware: catch logged-in users with no firstName on any page navigation.
 *
 * Covers cases the named `auth` middleware misses (public pages like TOP mentoring LP,
 * home, etc.) and social login users who bypass the modal flow.
 */
// Public pages a half-registered user must still be able to open (e.g. legal pages
// linked from the registration form itself). Without this, the redirect below bounces
// them back to registration and the link appears broken.
const ALLOWED_INCOMPLETE_PATHS = ['/pravidla-platformy', '/ochrana-sukromia']

export default defineNuxtRouteMiddleware(async (to) => {
    if (!import.meta.client) return
    if (to.path.startsWith('/auth/')) return
    if (ALLOWED_INCOMPLETE_PATHS.includes(to.path)) return

    const applicationStore = useApplicationStore()

    // Wait for auth plugin to finish loading (profile must be in store before we check)
    if (!applicationStore.authInitialized) {
        await new Promise<void>((resolve) => {
            const unwatch = watch(
                () => applicationStore.authInitialized,
                (initialized) => {
                    if (initialized) {
                        unwatch()
                        resolve()
                    }
                },
                { immediate: true }
            )
            setTimeout(() => {
                unwatch()
                resolve()
            }, 3000)
        })
    }

    // Only act on logged-in users whose profile is loaded but firstName is missing
    if (applicationStore.isLoggedIn && applicationStore.userProfile && !applicationStore.userProfile.firstName) {
        return navigateTo({ name: 'auth-registration', query: { redirect: to.fullPath } })
    }
})
